import { gql } from '@apollo/client'

export const GET_RETURN_CASE = gql`
  query getReturnCase($id: ID!) {
    returnCaseItem(id: $id) {
      id
      createdAt
      returnDate
      closedAt
      caseItem {
        caseType
      }
      employee {
        id
        contact {
          address {
            city
            country
            name
            nameAddition
            street
            streetAddition
            zipcode
          }
          firstName
          lastName
          email
          phoneNumber
        }
        office {
          id
          locationName
          address {
            city
            country
            name
            nameAddition
            street
            zipcode
          }
        }
      }
      latestShippingInfo {
        id
        carrier
        trackingReference
        trackingURL
        createdAt
      }
      returnLabelInfo {
        trackingReference
        pdfDownloadUrl
        isDangerousGoods
        dangerousGoodsPdf
      }
      rental {
        startAt
      }
      portalStatus
      hideReturnLabel
      showErasureReport
      stocklistItem {
        serialNumber
        imei
        imei2
        deviceDefinition {
          imageURL
          name
          productType
        }
      }
      trackingStatuses {
        totalCount
        trackingStatuses {
          status
          created
        }
      }
      deviceReport {
        id
        identifier
        processedOn
        fileName
        status
      }
    }
  }
`

export const GET_RETURN_CASE_PREVIEW_COLUMN = gql`
  query getReturnCasePreviewColumn($id: ID!) {
    returnCaseItem(id: $id) {
      id
      createdAt
      returnDate
      closedAt
      caseItem {
        caseType
      }
      employee {
        id
        contact {
          firstName
          lastName
        }
      }
      rental {
        startAt
      }
      stocklistItem {
        eid
        imei
        imei2
        serialNumber
        deviceDefinition {
          imageURL
          name
          productType
        }
      }
      portalStatus
    }
  }
`
